const ValidatKey = () => {

    return (
        <div className="col-12 col-md-5 ms-md-0 mt-4 mt-md-0 row valid-keys pb-2">

            <div className="col-8 valid-key-p1">
                <p className="valid-title"><span class="dot">•</span>معتبرسازی کلید شما</p>
                <p className="valid-text">
                    اگر کلید خود را از سامانه‌های دیگر دریافت کرده‌اید، می‌توانید از این قسمت نسبت به معتبرسازی آن اقدام نمایید.
                </p>

                <div style={{textAlign: "left"}}>
                    <button style={{ color: "#777777" }}>شروع فرایند</button>
                </div>

            </div>

            <div className="col-4 mt-3 text-center p-0">
                <button className="soon-btn px-2">به زودی</button>
                <img className="mt-3" src={require("../../../image/keyIcon.png")} />
            </div>

        </div>
    )
}

export default ValidatKey;